<template>
  <div>
    <div class="multidecimal-qty-container">
      <div class="cb-item__quantity">
        <div :class="{'cb-item__quantity cb-item__quantity--active': true, 'label-container': readOnly}">
          <label v-show="readOnly" id="md-qty-label" class="cb-transition__slide cb-transition__fade--short qty-label"
            @click="onFocus">
             {{ t('qty') }} 
          </label>
          <input
            ref="quantity"
            class="cb-item__control input-ellipsis"
            type="number"
            step="any"
            pattern="[0-9]+([\.][0-9]+)?"
            data-cb-id="item_quantity"
            v-model="currentQuantity"
            @keyup.enter="updateQuantity($event.target.value)"
            @blur="onBlur($event)"
            @focus="onFocus($event)"
          />
        </div>
      </div>
      <template v-if="hasChanged">
        <button class="cb-button cb-button__secondary cb-button__sm" @click="submit()">Update</button>
        <div class="cb-item__action cb-item__sub-group--inline" @click="resetQty()">
          <span>Cancel</span>
        </div>
      </template>
    </div>
    <cb-slide-n-fade>
      <div class="cb-text__error cb-transition__slide" v-if="errorMessage">{{errorMessage}}</div>
    </cb-slide-n-fade>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import MultiDecimalHelper from "@/utils/multi-decimal";
export default {
  data() {
    return {
      currentQuantity: this.quantity || this.meta.min,
      readOnly: true,
      showHelpText: false,
      errorMessage: "",
      labelWidth: 27 // variable to dynamically calculate offset width for qty label i18n
    };
  },
  props: {
    quantity: String,
    meta: [Object, Boolean],
    initialQuantity: Number | String,
  },
  watch: {
    currentQuantity(newValue, oldValue) {
      if (!this.isValid(newValue)) {
        this.errorMessage =
          this.t("multi_decimal.quantity.error") || "Enter valid quantity";
      } else {
        this.errorMessage = "";
      }
    },
  },
  computed: {
    type() {
      return this.meta && this.meta.type;
    },
    hasChanged() {
      if (!this.isValid(this.currentQuantity)) return false;
      return (
        MultiDecimalHelper.removeTrailingZeros(this.quantity) !==
        MultiDecimalHelper.removeTrailingZeros(this.currentQuantity)
      );
    },
    ...mapGetters(["multi_decimal_config"]),
  },
  mounted() {
    this.labelWidth = document.getElementById('md-qty-label').offsetWidth
    this.onBlur()
  },
  methods: {
    submit() {
      this.updateQuantity(this.currentQuantity);
    },
    onFocus() {
      this.showHelpText = true;
      this.readOnly = false;
      this.$refs.quantity.focus();
      this.$refs.quantity.style.paddingLeft = `5px`
    },
    onBlur($event) {
      this.readOnly = true;
      this.$refs.quantity.style.paddingLeft = `${this.labelWidth}px`
    },
    resetQty() {
      this.currentQuantity = this.quantity;
    },
    allowedInRange(value) {
      const decimalVal = parseFloat(value);
      try {
        if (this.type == "range") {
          return (
            decimalVal >= parseFloat(this.meta.min) &&
            decimalVal <= parseFloat(this.meta.max)
          );
        }
      } catch (e) {
        console.error(e);
      }
      return false;
    },
    updateQuantity(value) {
      this.currentQuantity = value;
      this.errorMessage = "";
      this.showHelpText = false;
      if (!this.isValid(value)) {
        if (!this.errorMessage) this.errorMessage = "Enter valid quantity";
        return;
      }

      if (this.type == "range" && !this.allowedInRange(value)) {
        this.errorMessage = `Please enter a value within the range (${this.meta.min}, ${this.meta.max})`;
        return;
      }

      // EBE TODO Check condition
      if (parseFloat(value) < parseFloat(this.initialQuantity)) {
        this.errorMessage = `Please enter a value greater than ${this.initialQuantity}`;
        return;
      }
      this.$emit("input", value);
    },
    isValid(value) {
      if (value.match(/^[0-9]+\.[0-9]+$/)) {
        const decimals = value.split(".")[1];
        if (
          decimals.length > this.multi_decimal_config.quantity_length ||
          !decimals.length
        )
          return false;
      } else if (!value.match(/^[0-9]+$/)) return false;
      return true;
    },
  },
};
</script>
<style  lang="stylus" scoped>
.cb-item__control {
  height: 25px;
  width: 96px;
  font-size: 12px;
  border-radius: 2px;
  border: 1px solid white;
}

.cb-item__control:focus {
  border: 1px solid rgba(0, 82, 204, 0.56);
}

.cb-button__sm {
  color: rgb(33, 150, 243);
  margin: 0 8px;
  height: 25px;
}

.cb-cart--multiple .cb-item__control.cb-item__control--sm {
  font-size: 9px;
}

input[type='number'], .cb-item__control, .cb-item__control:hover, .cb-item__control:focus {
  -moz-appearance: textfield;
}

input::-webkit-outer-spin-button, input::-webkit-inner-spin-button, .cb-item__control::-webkit-outer-spin-button:hover, .cb-item__control::-webkit-inner-spin-button:hover, .cb-item__control::-webkit-outer-spin-button:focus, .cb-item__control::-webkit-inner-spin-button:focus {
  -webkit-appearance: none;
}

.multidecimal-qty-container {
  display: flex;
  align-items: center;
}

.input-ellipsis {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  padding-right: 5px;
  transition: padding-left 0.2s ease;
}

.label-container {
  display: flex;
  position: relative;
  align-items: center;
}

.qty-label {
  position: absolute;
  padding-left: 5px;
  font-size: 12px;
  color: #93939E;
  cursor: pointer;
}
</style>